import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { CommonService } from './../common.service';
import { NgxSpinnerService } from "ngx-spinner";
import { SelectDropDownComponent } from 'ngx-select-dropdown';
import { CommonVariablesService } from './../common-variables.service';
import { noop, Observable, Observer, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { from } from 'rxjs';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css']

})
export class ContactusComponent implements OnInit {

  @ViewChild(SelectDropDownComponent, { "static": false })
  ngxselectRef: SelectDropDownComponent
  contactUsForm: FormGroup;
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any;
  submitted = false;
  noResult = false;
  policyRefNumber:string;
  selectedPolicyData: Observable<any>;
  policyNumberDropdown: any;
  getRequestNo: any;
  selected: string;
  selectedPolicy: any = [];

  config1: any = {
    displayKey: "cust_fld_1",
    search: true,
    height: 'auto',
    placeholder: 'Please Select Policy Number',
    customComparator: () => { },
    limitTo: 10,
    moreText: 'more',
    noResultsFound: 'No results found!',
    searchPlaceholder: 'Search Policy Number',
    searchOnKey: "cust_fld_1"
  }

  constructor(private formBuilder: FormBuilder,
    private commonService: CommonService,
    private commonVariablesService: CommonVariablesService,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.selectedPolicyData = new Observable((observer: Observer<string>) => {
            observer.next(this.selected);
            
        })
        .pipe(
            switchMap((query: string) => {
                return from(this.loadPolicyNumber(query)).pipe(
                        map((data: any) => data || []),
                        tap(() => noop, err => { console.log('Something goes wrong'); })
                    );
            })
        );
    window.localStorage.setItem('pageName','');
    this.contactUsForm = this.formBuilder.group({
      contactUsPolicyNum: ['', Validators.required],
      contactUsOption: ['', Validators.required],
      contactUsTextArea: ['', Validators.required]
    });
   

  }
  /*
 * Created By : Keerthana
 * Description : validates validateform fields.
 *********************************************/
  get f() { return this.contactUsForm.controls; }

  /*
 * Created By : Keerthana
 * Description : Load policy number with in dropdown.
 *********************************************/
    async policyNumberChange() {
        let policyData = this.selectedPolicy;
    console.log("policyData",policyData)
    this.policyRefNumber = policyData.policy_ref_num;
        let policyNumber = policyData.cust_fld_1.split('-');
    //  this.selectedItemsRoot = [];
        let url = this.commonVariablesService.baseURL + "api/v1/marine_soa/policy_list?"
        if(policyData) {
            let params = {
                policy_no:policyNumber[0],
                policy_ref_num:policyData.policy_ref_num,
                module_name:'CONTACTUS'
            }
      let response = await this.commonService.httpGetMethod(url, '', true,params, 'Contact Us');
        if (response.status == 0) {
          this.unique(response.data);
        }
        else if (response.status != -114) {
          this.commonService.errorsmsg(response.txt, 'Error');
        }
        }       
        this.dtTrigger.next();
    }

  async loadPolicyNumber(policyNo) {
    if(policyNo.length >= 6){
    this.spinner.show();
    let url = this.commonVariablesService.baseURL + "api/v1/marine_soa/policy_list"
    let params = {
      policy_no:policyNo,
      module_name:'CONTACTUS'
    }
    let response = await this.commonService.httpGetMethod(url, '', true,params, 'Contact Us');
    if (response.status == 0) {
      for(let i in response.data)
      {
        response.data[i].search_val = (response.data[i].cust_fld_1 || '');
      }
      return this.unique(response.data);
    }
    else if (response.status != -114) {
      this.commonService.errorsmsg(response.txt, 'Error');
    }
    this.dtTrigger.next();
  }
  }
    /*
    * Created By : Keerthana
    * Description : Removes the duplicate policy numbers from object.
    *********************************************/
  unique(obj) {
    let newArray = [];
    let uniqueObject = {};
    for (let i in obj) {
      let objTitle = obj[i].policy_ref_num;
      if(obj[i].renewal_counter)
        obj[i].cust_fld_1 = obj[i].cust_fld_1+' - '+obj[i].renewal_counter;
      uniqueObject[objTitle] = obj[i];
    }

    for (let i in uniqueObject) {
      newArray.push(uniqueObject[i]);
    }
    return newArray
   // this.policyNumberDropdown = newArray;
  }
  typeaheadNoResults(event: boolean): void {
        if ((this.commonVariablesService.gcPolicyNoFromHeaderSearch).length >= 6) {
            this.noResult = event;
        }
    }

  /*
  * Created By : Keerthana
  * Description : This function is used to send request.
  *********************************************/
  async onSubmit() {
    if (this.contactUsForm.invalid) {
      this.submitted = true;
      return;
    }
    else {

      if (this.contactUsForm.value.contactUsOption == 'Increase in Sum Insured') {
        this.commonService.errorsmsg('Not Available', 'Error');
        return;
      }
      this.spinner.show();
      var option;

      if (this.contactUsForm.value.contactUsOption == 'Change in Per Sending Limit') {
        option = 'psl';
      }
      else if (this.contactUsForm.value.contactUsOption == 'Update Mode of Conveyance') {
        option = 'conveyance';
      }
      else if (this.contactUsForm.value.contactUsOption == 'Any Other Request') {
        option = 'any_other';
      }
      console.log(this.contactUsForm.controls);
      let url = this.commonVariablesService.baseURL + 'api/v1/marine_log/insert_log_request/contact_us';
   console.log("split",this.contactUsForm)
      var contactusObj = {};
      contactusObj['selectedOptionForUrl'] = option;
      contactusObj['policy_ref_num'] = this.policyRefNumber;
      /* contactusObj['users'] = [this.cookie.get('email')]; */
      contactusObj['users'] = [window.localStorage.getItem('email')];
      contactusObj['selectedOption'] = this.contactUsForm.value.contactUsOption;
      contactusObj['policy_no'] = this.contactUsForm.value.contactUsPolicyNum;
      /* contactusObj['clientName'] = this.cookie.get('name'); */
      contactusObj['clientName'] = window.localStorage.getItem('name');
      contactusObj['txtByClient'] = this.contactUsForm.value.contactUsTextArea;
      /*contactusObj['token'] = sessionStorage.getItem('token');*/
      /* contactusObj['token'] =window.localStorage.getItem('token'); */
      contactusObj['type'] = 'Contact Us';
      contactusObj['description'] = this.contactUsForm.value.contactUsOption + '~' + this.contactUsForm.value.contactUsTextArea;

      let response = await this.commonService.httpPostMethod(url, contactusObj, 'application/json', true, 'Contact Us');

      if (response.body.status == 0) {
        this.commonService.successmsg("Your request is submitted successfully and your request number is " + response.body.data.request_no, "Success")
        this.resetForm();
      }
      else if (response.body.status != -114) {
        this.commonService.errorsmsg('Unable to submit your Request', 'Error');
      }
    }
  }

  /*
    * Created By : Keerthana
    * Description : Resets the form.
    *********************************************/
  resetForm() {
    this.contactUsForm.reset();
    this.submitted = false;

  }
  /*
    * Created By : Balbir Kaur
    * Description : navigate to declaration page on dropdown select.
    *********************************************/
    async typeaheadOnSelect(e: any, isManuallyTrigger: boolean = false) {
        this.selectedPolicy = [];
        this.selected = e.value ? e.value : "";
        this.selectedPolicy = e.item
        await this.policyNumberChange()
    }
  
    /*
    * Created By : Sharann N
    * Description : to download contact-us pdf.
    *********************************************/
  downloadContactUsLink() {
    const fileName = `Emarine 2 0.pdf`;
    const dwldSampleUrl = `./assets/pdf/${fileName}`;
    let link = document.createElement("a");
    link.download = fileName;
    link.href = dwldSampleUrl;
    link.click();
  }

}
